import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useTutorSession } from '../context/TutorSessionContext.tsx';

const TutorSessionEntry: React.FC = () => {
  const { sessionId } = useParams<{ sessionId: string }>();
  const [search] = useSearchParams();
  const navigate = useNavigate();
  const { activateSession } = useTutorSession();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!sessionId) {
        if (!cancelled) setError('Missing tutor session id.');
        return;
      }
      try {
        const returnUrl = search.get('return') ?? undefined;
        await activateSession(sessionId, returnUrl);
        if (!cancelled) {
          navigate('/tests', { replace: true });
        }
      } catch (e: any) {
        if (!cancelled) setError(e?.message ?? 'Failed to activate tutor session.');
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [activateSession, navigate, search, sessionId]);

  if (error) {
    return (
      <Box sx={{ maxWidth: 700, mx: 'auto', p: 3 }}>
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }
  return (
    <Box sx={{ minHeight: '40vh', display: 'grid', placeItems: 'center' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <CircularProgress size={20} />
        <Typography>Starting tutor session…</Typography>
      </Box>
    </Box>
  );
};

export default TutorSessionEntry;
